import Logo from './../../components/Logo.jsx'
import ResultContainer from './ResultContainer.jsx'
import SearchParameters from './SearchParameters.jsx'
import Header from './Header.jsx'
import ExportTableContainer from './ExportTableContainer.jsx'
import AdditionalInfo from './AdditionalInfo.jsx'
import useKeyHandler from './useKeyHandler.js'
import React, { useEffect } from 'react'
import './index.css'
import Footer from '../../components/Footer/index.jsx'
import axiosInstance from './../../util/axios.js'
import { API_ROUTES } from './../../util/constants.js'

export default function FilterArtwork() {
	const [ownerList, setOwnerList] = React.useState([])
	const [artistList, setArtistList] = React.useState([])
	const [artworkResultList, setArtworkResultList] = React.useState([])
	const [selectedArtwork, setSelectedArtwork] = React.useState(null)
	const [keyEvent, keysPressed] = useKeyHandler()
	const [searchParams, setSearchParams] = React.useState({})

	useEffect(() => {
		console.log('fetch owner/artist names')
		axiosInstance
			.get(API_ROUTES.OWNER_NAMES)
			.then((result) => setOwnerList(result))
			.catch((error) => console.error('Failed to load owner names', error))

		axiosInstance
			.get(API_ROUTES.ARTIST_NAMES)
			.then((result) => setArtistList(result))
			.catch((error) => console.error('Failed to load artist names', error))
	}, [])
	useEffect(() => {
		var shiftCode = 16
		const leftKeyCode = 37
		const rightKeyCode = 39

		if (keyEvent && keyEvent.eventName === 'keydown') {
			switch (keyEvent.keyCode) {
				case leftKeyCode:
					//console.log('Left key is pressed. shift: ' + isKeyPressed(shiftCode));
					if (!inputFieldFocused()) {
						if (keysPressed.indexOf(shiftCode) < 0) {
							//previous
							setSelectedArtwork((state) => {
								const index =
									artworkResultList.findIndex((e) => e === selectedArtwork) - 1
								if (index >= 0) {
									return artworkResultList[index]
								} else {
									return state
								}
							})
						} else {
							setSelectedArtwork(
								artworkResultList.length ? artworkResultList[0] : null
							)
						}
					}
					break
				case rightKeyCode:
					//console.log('Right key is pressed.');
					if (!inputFieldFocused()) {
						if (keysPressed.indexOf(shiftCode) < 0) {
							//next
							setSelectedArtwork((state) => {
								const index =
									artworkResultList.findIndex((e) => e === selectedArtwork) + 1
								if (index < artworkResultList.length) {
									return artworkResultList[index]
								} else {
									return state
								}
							})
						} else {
							setSelectedArtwork(
								artworkResultList.length
									? artworkResultList[artworkResultList.length - 1]
									: null
							)
						}
					}
					break
			}
		}

		function inputFieldFocused() {
			var f = document.activeElement
			//console.log('inputField class name ' + f.id);
			if (
				f.id == 'selectOwner' ||
				f.id == 'selectArtist' ||
				f.id == 'selectTitle'
			) {
				return true
			} else {
				return false
			}
		}
	}, [keysPressed, keyEvent, artworkResultList])

	function onSearchTriggered(searchParams) {
		setWaitButtonCursor()
		setSelectedArtwork(null)
		setSearchParams(searchParams)

		const { artistId, ownerId, title } = searchParams

		axiosInstance
			.get(API_ROUTES.ARTWORKS_SEARCH, {
				params: {
					ownerId: ownerId || null,
					artistId: artistId || null,
					title: title || null,
				},
			})
			.then((data) => {
				resetButtonCursor()
				setArtworkResultList(Array.isArray(data) ? data : [])
			})
			.catch((error) => {
				resetButtonCursor()
				console.error(error)
			})

		function setWaitButtonCursor() {
			document.getElementsByTagName('body')[0].style.cursor = 'wait'
			document.getElementById('submitButton').style.cursor = 'wait'
		}

		function resetButtonCursor() {
			setTimeout(function () {
				document.getElementsByTagName('body')[0].style.cursor = 'default'
				document.getElementById('submitButton').style.cursor = 'pointer'
			}, 100)
		}
	}

	function findArtistFullName(searchId, entryId, displayId = true) {
		const notFoundElement = 'Unbekanter Kuenstler'
		for (const e of artistList) {
			if (e.id === searchId) {
				return displayId
					? `${e.lastname} ${e.firstname} [${entryId}]`
					: `${e.lastname} ${e.firstname}`
			}
		}
		return notFoundElement
	}

	function findOwnerFullName(searchId, entryId, displayId = true) {
		const notFoundElement = 'Unbekanter Besitzer'
		for (const e of ownerList) {
			if (e.id === searchId) {
				return displayId
					? `${e.lastname} ${e.firstname} [${entryId}]`
					: `${e.lastname} ${e.firstname}`
			}
		}
		return notFoundElement
	}
	return (
		<div>
			<Logo />
			<div id='mainFlexContainer'>
				<div id='topFlexContainer'>
					<Header />
					<div className='divisionLine'> </div>
					<SearchParameters
						onSearchTriggered={onSearchTriggered}
						ownerList={ownerList}
						artistList={artistList}
					/>
					<ExportTableContainer
						loadedData={artworkResultList}
						searchParams={searchParams}
						findArtistFullName={findArtistFullName}
						findOwnerFullName={findOwnerFullName}
					/>
				</div>
				<div id='bottomFlexContainer'>
					<ResultContainer
						data={artworkResultList}
						selectedArtwork={selectedArtwork}
						setSelectedArtwork={setSelectedArtwork}
						findArtistFullName={findArtistFullName}
						findOwnerFullName={findOwnerFullName}
					/>
					{selectedArtwork && (
						<AdditionalInfo selectedArtwork={selectedArtwork} />
					)}
				</div>
				<Footer />
			</div>
		</div>
	)
}
